import React from 'react';
import styled, { css } from 'styled-components';
import { COLORS, FONT_WEIGHTS, mediaQueries } from '../../theme';
import { ForwardRefProps } from '../../utils/forwardRefs';
import { BaseHeading } from './BaseHeading';
import { HeadingProps, HeadingPropsWithInnerRef } from './types';

const SecondaryHeadingComponent: React.FC<
  React.PropsWithChildren<React.PropsWithChildren<HeadingPropsWithInnerRef>>
> = ({ children, innerRef, level = 2, tabIndex, withoutMargin = false, id }) => (
  <StyledHeading
    level={level}
    tabIndex={tabIndex}
    $withoutMargin={withoutMargin}
    ref={innerRef}
    id={id}
  >
    {children}
  </StyledHeading>
);

export const secondaryHeadingStyles = css`
  font-family: ${(props) => props.theme.font.default};
  color: ${COLORS.TEXT};
  font-weight: ${FONT_WEIGHTS.BOLD};
  font-size: 1.5rem;
  line-height: 120%;
  word-break: break-word;
  hyphens: auto;
  overflow-wrap: break-word;

  ${mediaQueries({
    medium: css`
      line-height: 133%;
    `,
  })}
`;

const StyledHeading = styled(BaseHeading)<{ $withoutMargin: boolean }>`
  ${secondaryHeadingStyles};
  margin-bottom: ${(props) => (props.$withoutMargin ? '0' : '10px')};
`;

/**
 * @deprecated Use h2 with tailwind classes instead.
 */
export const SecondaryHeading = React.forwardRef<HTMLHeadingElement, ForwardRefProps<HeadingProps>>(
  (props, ref) => {
    return <SecondaryHeadingComponent innerRef={ref} {...props} />;
  }
);
